import {
    FETCH_DDMASTER_REQUEST,
    FETCH_DDMASTER_SUCCESS,
    FETCH_DDMASTER_FAILURE
}
from "../actions/dropdownmasteraction"

const initialState = {
    loading: false,
    ddmaster: [],
    error: ''

}

const dropdownmasterreducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_DDMASTER_REQUEST:
        return {
            ...state,
            loading:true

        }

        case FETCH_DDMASTER_SUCCESS:
        return {
            ...state,
            loading:false,
            ddmaster: action.payload,
            error: ''
            

        }
        case FETCH_DDMASTER_FAILURE:
            return {
                ...state,
                loading: false,  
                ddmaster: [],  
                error: action.payload  
            }
        
        default:
            return state;
    }

}

export default dropdownmasterreducer